/**
 * Catálogo: Forma de pago del inmueble. Const portable, framework-agnostic.
 */
export const PaymentMethod = {
  BANK_CREDIT: 'BANK_CREDIT',
  CASH: 'CASH'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]

export const PaymentMethodLabel = {
  [PaymentMethod.BANK_CREDIT]: 'Crédito Bancario',
  [PaymentMethod.CASH]: 'Contado'
} as const satisfies Record<PaymentMethod, string>

export const PaymentMethodOptions = Object.values(PaymentMethod).map((value) => ({
  value: PaymentMethodLabel[value],
  label: PaymentMethodLabel[value]
}))
